import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { OtherTradeName } from '../../api/types';
import trns from './trns';
import NextImage from '../NextImage/NextImage';
import NavigationLink from '../NavigationLink/NavigationLink';
import useGTAG from '../../hooks/useGTAG';

interface Props {
  otherTradeNamesList: OtherTradeName[] | null;
}

const chevronRight = 'tradename/chevron_right.svg';
const AnaloguesList: FC<Props> = ({ otherTradeNamesList }) => {
  const { trackGtagEvent } = useGTAG();

  return (
    <div className="lm:mx-0 mx-4">
      <h3 className="fs-header5-bold text-darkBlue uppercase mb-6">
        <FormattedMessage {...trns.interestedIn} />
      </h3>
      <div className="flex-col lm:flex lm:flex-wrap lm:flex-row">
        {otherTradeNamesList.slice(0, 5).map((analogue, index) => (
          <button
            key={index}
            className="lm:w-auto w-full h-[40px] border border-alto rounded-[6px] bg-white flex justify-center items-center px-4 mr-2 mb-2 hover:shadow-sm"
          >
            <NavigationLink
              key={index}
              href={{ pathname: `/tradename/${analogue.translitName}` }}
              passClassName="fs-body-reg capitalize hover:underline text-bahamaBlue"
              onClick={() => {
                trackGtagEvent(
                  'tradename_interesting_tradenames',
                  analogue.name,
                  'tradename_name'
                );
              }}
            >
              {analogue.name.toLowerCase()}
            </NavigationLink>

            <div className="flex justify-center ml-2">
              <NextImage
                alt="check Circle"
                src={chevronRight}
                layout="fixed"
                width={24}
                height={24}
              />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default AnaloguesList;
